/**
 * Chip label helpers for the Reserved Item Expiration sidebar filter.
 */
import { RESERVED_ITEM_EXPIRATION_TYPE } from "../../../../../../../services/api/rma-list-service";
import {
    formatChipCalendarDate,
    isoRangeStringToCalendarRange,
} from "../../../../../../../utilities/date-utilities";

const formatDateRangeChipLabel = (isoRange: string, timeZone: string): string | undefined => {
    const range = isoRangeStringToCalendarRange(isoRange, timeZone);
    if (!range) {
        return undefined;
    }

    return `${formatChipCalendarDate(range.from)} - ${formatChipCalendarDate(range.to)}`;
};

const formatDaysRemainingChipLabel = (from?: number, to?: number): string | undefined => {
    if (from === undefined || to === undefined) {
        return undefined;
    }
    return `${from} To ${to} Days`;
};

interface IGetReservedItemSelectedLabelParams {
    selectedId: RESERVED_ITEM_EXPIRATION_TYPE;
    expiredLabel?: string;
    daysFrom?: number;
    daysTo?: number;
    dateRangeIso: string;
    timeZone: string;
}

export const getReservedItemSelectedLabel = ({
    selectedId,
    expiredLabel,
    daysFrom,
    daysTo,
    dateRangeIso,
    timeZone,
}: IGetReservedItemSelectedLabelParams): string | undefined => {
    switch (selectedId) {
        case RESERVED_ITEM_EXPIRATION_TYPE.EXPIRED:
            return expiredLabel;
        case RESERVED_ITEM_EXPIRATION_TYPE.DAYS_REMAINING:
            return formatDaysRemainingChipLabel(daysFrom, daysTo);
        case RESERVED_ITEM_EXPIRATION_TYPE.DATE_RANGE:
            return formatDateRangeChipLabel(dateRangeIso, timeZone);
        default:
            return undefined;
    }
};
